<script setup lang="ts">
import type { FormKitFrameworkContext } from '@formkit/core'
import type { TLDocInput, TLDocInputValue } from '~/types/formkit-custom'

type TContext = FormKitFrameworkContext<TLDocInputValue> & TLDocInput

const props = defineProps({
  context: {
    type: Object as PropType<TContext>,
    default: null
  }
})

const ext2FileType: Record<string, string> = {
  '.pdf': 'application/pdf'
}

function validateFileTypes(files: File[] | FileList | null) {
  // Reject wrong file types
  if (props.context.accept) {
    const acceptTypes = props.context.accept.split(',').map((type) => ext2FileType[type])

    for (const file of files || []) {
      console.log('file.type', file.type, acceptTypes)
      if (!acceptTypes.includes(file.type)) {
        alert(`File type not accepted: ${file.type}`)
        return false
      }
    }
  }
  return true
}

function commitFiles(files: File[] | FileList | null) {
  // Reject empty files
  if (!files) return false
  props.context.node.input(files[0])
}

function handleFileInput(event: Event) {
  const target = event.target as HTMLInputElement
  if (validateFileTypes(target.files)) {
    commitFiles(target.files)
  }
}

// function resetFileInput() {
//   props.context.node.input(null)
// }
</script>

<template>
  <div class="document-input">
    <div class="document-upload">
      <div class="document-upload-link clickable">
        <span v-if="!props.context.value">+ Upload</span>
        <span v-else>Update</span>
        <input
          type="file"
          :accept="props.context.accept"
          class="fileinput"
          @change="handleFileInput"
        >
      </div>
    </div>

    <div class="document-check"/>

    <div v-if="props.context.value" class="document-show">
      <CommonIconDocument />

      <div>
        <div>{{ (props.context.value as File).name }}</div>
        <div>{{ ((props.context.value as File).size / (1024 * 1024)).toFixed(2) }} MB</div>
      </div>

      <!-- <iframe :src="resumeSrc" type="application/pdf" height="100" width="200"></iframe> -->
    </div>
  </div>
</template>

<style lang="scss" scoped>
.document {
  &-input {
    min-height: 40px;
  }

  &-show {
    background: var(--bgMedium);
    border-radius: 10px;
    margin: 20px 0 20px;
    overflow: hidden;
    padding: 15px;
    // height: 300px;8
    font-size: 0.95rem;
    line-height: 1.4rem;
    display: flex;
    align-items: center;
    gap: 20px;

    svg {
      $size: 25px;
      height: $size;
      width: $size;
      fill: var(--textLight);
    }

    iframe {
      width: 100%;
      height: 100%;
      outline: none;
      border: none;
    }
  }

  &-upload {
    &-link {
      cursor: pointer;
      position: relative;
      user-select: none;
      font-weight: 500;
      font-size: 0.95rem;
      color: var(--purple);
      border: 1px solid var(--purple);
      padding: 5px 17px 5px 15px;
      border-radius: 20px;
      transition:
        background 0.3s ease-out,
        coolor 0.3s ease-out;

      input[type='file'] {
        cursor: pointer;
        height: 1.5rem;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        opacity: 0;
      }
    }
  }
}

@media (hover: hover) {
  .document {
    &-upload-link:hover {
      cursor: pointer;
      background: var(--purple);
      color: white;
    }
  }
}
</style>
